if (!window.__productCouponBound) {
  window.__productCouponBound = true;

  const parseCouponEndTime = (rawValue) => {
    const value = String(rawValue || '').trim();
    if (!value) return NaN;

    const durationMatch = value.match(/^(?:(\d+)\s*(?:d|day|days)\s*)?(\d{1,2}):(\d{2})(?::(\d{2}))?$/i);
    if (durationMatch) {
      const [, days = '0', hours = '0', minutes = '0', seconds = '0'] = durationMatch;
      const duration =
        Number(days) * 86400000 +
        Number(hours) * 3600000 +
        Number(minutes) * 60000 +
        Number(seconds) * 1000;

      return Date.now() + duration;
    }

    if (/^\d+$/.test(value)) {
      const timestamp = Number(value);
      return timestamp < 10000000000 ? timestamp * 1000 : timestamp;
    }

    const normalized = value.replace(/\//g, '-');
    const hasTimezone = /(?:z|[+-]\d{2}:?\d{2})$/i.test(normalized);
    if (hasTimezone) {
      return new Date(normalized.replace(' ', 'T')).getTime();
    }

    const match = normalized.match(
      /^(\d{4})-(\d{1,2})-(\d{1,2})(?:[ T](\d{1,2})(?::(\d{1,2}))?(?::(\d{1,2}))?)?$/
    );

    if (match) {
      const [, year, month, day, hours = '23', minutes = '59', seconds = '59'] = match;
      return new Date(
        Number(year),
        Number(month) - 1,
        Number(day),
        Number(hours),
        Number(minutes),
        Number(seconds)
      ).getTime();
    }

    return new Date(normalized).getTime();
  };

  const formatCouponTime = (distance) => {
    const totalSeconds = Math.max(0, Math.floor(distance / 1000));
    const days = Math.floor(totalSeconds / 86400);
    const hours = Math.floor((totalSeconds % 86400) / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;
    const pad = (value) => String(value).padStart(2, '0');

    return `${days} Days ${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
  };

  const updateCouponCountdowns = () => {
    document.querySelectorAll('[data-coupon-countdown]').forEach((node) => {
      const valueNode = node.querySelector('[data-coupon-countdown-value]');
      if (!valueNode) return;

      const targetValue = node.dataset.endAt || valueNode.textContent.trim();
      if (!targetValue) return;

      if (!node.dataset.endAt) {
        node.dataset.endAt = targetValue;
      }

      if (!node.dataset.couponEndTime || node.dataset.couponParsedFrom !== node.dataset.endAt) {
        const endAt = parseCouponEndTime(node.dataset.endAt);
        node.dataset.couponParsedFrom = node.dataset.endAt;

        if (Number.isNaN(endAt)) {
          node.dataset.couponInvalid = 'true';
          return;
        }

        node.dataset.couponInvalid = 'false';
        node.dataset.couponEndTime = String(endAt);
      }

      if (node.dataset.couponInvalid === 'true') return;

      const distance = Number(node.dataset.couponEndTime) - Date.now();
      if (distance <= 0) {
        node.closest('.product-coupon') ? node.closest('.product-coupon').style.display = 'none' : '';
        return;
      }

      valueNode.textContent = formatCouponTime(distance);
    });
  };

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-coupon-copy]');
    if (!button) return;

    const code = button.dataset.couponCode || '';
    if (!code) return;

    try {
      await navigator.clipboard.writeText(code);
      button.dataset.originalText = button.dataset.originalText || button.textContent;
      button.textContent = 'Copied';
      setTimeout(() => {
        button.textContent = button.dataset.originalText;
      }, 1600);
    }
    catch (error) {
      const input = document.createElement('input');
      input.value = code;
      document.body.append(input);
      input.select();
      document.execCommand('copy');
      input.remove();
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateCouponCountdowns, { once: true });
  }
  else {
    updateCouponCountdowns();
  }

  document.addEventListener('product-info:loaded', updateCouponCountdowns);
  document.addEventListener('quickview:loaded', updateCouponCountdowns);
  setInterval(updateCouponCountdowns, 1000);
}

if (!window.__freeGiftExposeItemBound) {
  window.__freeGiftExposeItemBound = true;

  const updateFreeGiftExposeItemIds = (mainVariantId) => {
    if (!mainVariantId) return;

    document.querySelectorAll('.free-gift-item[data-gift-variant-id]').forEach((item) => {
      item.dataset.mainVariantId = String(mainVariantId);
      item.dataset.exposeItemId = `${mainVariantId}_${item.dataset.giftVariantId}`;
    });
  };

  document.addEventListener('variant:change', (event) => {
    updateFreeGiftExposeItemIds(event.detail?.variant?.id);
  }, true);
}

if (!window.__toolsChooseTriggerBound) {
  window.__toolsChooseTriggerBound = true;

  document.addEventListener('click', function(event) {
    const trigger = event.target.closest('[data-tools-choose-trigger]');
    if (!trigger) return;

    const container = trigger.closest('.tools-choose-container');
    const toolsChoose = container?.querySelector('.tools-choose');
    if (!toolsChoose) return;

    const isOpen = toolsChoose.classList.toggle('show');
    trigger.classList.toggle('is-open', isOpen);
  });
}
